// extracted by mini-css-extract-plugin
export var fadeInAnimation = "AsideFooter-module--fadeInAnimation--aa855";
export var title = "AsideFooter-module--title--27213";
export var wrapper = "AsideFooter-module--wrapper--95089";